module.exports = __webpack_public_path__ + "img/loader.bf31f0d5.gif";